import React from "react";
import { Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative border-t border-zinc-900 pt-16 pb-28 md:pb-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <div className="h-9 w-9 rounded-lg bg-cyan-400 flex items-center justify-center shadow-[0_0_20px_rgba(34,211,238,0.4)]">
                <span className="text-zinc-950 font-black text-lg">B</span>
              </div>
              <div>
                <div className="font-black tracking-tight">B&amp;B Auto Detailing</div>
                <div className="text-[10px] uppercase tracking-[0.2em] text-cyan-400 font-bold">
                  Santa Rosa · Sonoma County
                </div>
              </div>
            </div>
            <p className="mt-5 text-sm text-zinc-400 max-w-sm">
              Premium hand-detailing across Santa Rosa &amp; Sonoma County. Showroom shine,
              right at your driveway.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500 mb-4">
              Services
            </div>
            <ul className="space-y-2 text-sm text-zinc-400">
              <li><a href="#services" className="hover:text-cyan-400 transition-colors">Interior Detail · $65</a></li>
              <li><a href="#services" className="hover:text-cyan-400 transition-colors">Exterior Detail · $50</a></li>
              <li><a href="#services" className="hover:text-cyan-400 transition-colors">Full Detail · $110</a></li>
              <li><a href="#booking" className="hover:text-cyan-400 transition-colors">Book Online</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500 mb-4">
              Contact
            </div>
            <ul className="space-y-3 text-sm text-zinc-300">
              <li>
                <a
                  href="tel:+17079090231"
                  className="inline-flex items-center gap-2 hover:text-cyan-400 transition-colors"
                  data-testid="footer-phone"
                >
                  <Phone className="h-4 w-4 text-cyan-400" /> (707) 909-0231
                </a>
              </li>
              <li className="inline-flex items-center gap-2">
                <MapPin className="h-4 w-4 text-cyan-400" /> Santa Rosa, CA · Sonoma County
              </li>
              <li className="text-zinc-500 text-xs pt-2">Open daily · Closes 8 PM</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-zinc-900 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-zinc-500">
          <div>© {new Date().getFullYear()} B&amp;B Auto Detailing. All rights reserved.</div>
          <div>Crafted with care in Sonoma County.</div>
        </div>
      </div>
    </footer>
  );
}
